import { render, staticRenderFns } from "./PublicForm.vue?vue&type=template&id=078daa42"
var script = {}
import style0 from "./PublicForm.vue?vue&type=style&index=0&id=078daa42&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports